export default __webpack_public_path__ + "static/px10-d0e36908f468a49af24d692741cb6034.jpg";